import { useCallback } from "react";
import { useGameStateContext } from "../GameStateProvider";
import { useAudioContext } from "../AudioProvider";
import { isActionAllowedInTutorial } from "../utils/tutorialUtils";

export const useCustomerActions = () => {
  const { state, dispatch } = useGameStateContext();
  const audio = useAudioContext();

  const handleServeCustomer = useCallback(
    (customerId: string, itemId: string) => {
      if (!isActionAllowedInTutorial({ type: "serve", itemId }, state.tutorialState)) {
        return;
      }
      if (state.inventory[itemId] <= 0) return;

      dispatch({
        type: "SERVE_CUSTOMER",
        customerId,
        itemId,
      });

      audio.playSfx("serve");
    },
    [state.inventory, state.tutorialState, dispatch, audio]
  );

  const canServeCustomerInTutorial = useCallback(
    (customer) => {
      return isActionAllowedInTutorial({ type: "serve", itemId: customer.order }, state.tutorialState);
    },
    [state.tutorialState]
  );

  return {
    handleServeCustomer,
    canServeCustomerInTutorial,
  };
};
